import React from 'react';
import CrossIcon from "../../assets/icons/cross";

export default function Modal({
    title,
    children,
    footer,
    onClose,
}) {
    return (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          onClick={onClose}
        >
            <div
              className="bg-white rounded shadow-lg max-w-xl w-full m-6"
              onClick={e => e.stopPropagation()}
            >
                <div className="flex items-center justify-between p-4 border-b">
                    <h3 className="text-xl font-semibold">
                        {title}
                    </h3>
                    <button type="button" onClick={onClose} className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-6 h-auto ms-auto inline-flex justify-center items-center">
                        {CrossIcon(8)}
                    </button>
                </div>
                {children}
                {footer && (
                    <div className="flex items-center space-x-4 p-4 border-t">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
};
